import { useState, useEffect } from 'react';

export const useDeviceDetection = () => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    // Initial check
    const checkDevice = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Check on mount
    checkDevice();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkDevice);
    
    // Clean up
    return () => {
      window.removeEventListener('resize', checkDevice);
    };
  }, []);
  
  return { isMobile };
};

export default useDeviceDetection;